"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const reducer_1 = __importDefault(require("./external/transactions/reducer"));
const reducer_2 = __importDefault(require("./external/multicall/reducer"));
const reducer_3 = __importDefault(require("./external/application/reducer"));
const store = (0, toolkit_1.configureStore)({
    reducer: {
        transactions: reducer_1.default,
        application: reducer_3.default,
        multicall: reducer_2.default,
    },
});
exports.default = store;
